import React, { useCallback, useMemo, useState } from "react";
import { Platform, View } from "react-native";
import { Link as AuroraLink } from "@lookiero/aurora";
import { useI18nMessage, useI18n } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Icon, Modal } from "@lookiero/sty-psp-ui";
import { I18nMessages } from "../../../../../../../i18n/i18n";
import { getSilhouetteGuide } from "./SilhouetteGuide.contants";
import { style as silhouetteGuideStyle } from "./SilhouetteGuide.style";
const SilhouetteGuide = ({ domain, segment, i18nPrefix, portalHostName, tradename, onOpenSilhouetteGuide, }) => {
    const style = useMemo(() => silhouetteGuideStyle(), []);
    const [visible, setVisible] = useState(false);
    const handleOnOpen = useCallback(() => {
        setVisible(true);
        onOpenSilhouetteGuide?.();
    }, [onOpenSilhouetteGuide]);
    const handleOnClose = useCallback(() => setVisible(false), []);
    const Link = useMemo(() => (Platform.OS === "web" ? AuroraLink : Text), []);
    const { formatMessage } = useI18n({ domain });
    const description = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SILHOUETTE_SUBTITLE,
        values: { segment: segment.toLowerCase() },
    });
    const descriptionLinkText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SILHOUETTE_GUIDE_LINK,
        values: { segment: segment.toLowerCase() },
    });
    const descriptionLink = formatMessage({ id: `${i18nPrefix}${I18nMessages.SILHOUETTE_SILHOUETTE_GUIDE}` }, {
        link: (React.createElement(Link, { level: 3, style: [style.description, style.link], testID: "silhouette-guide-link", onPress: handleOnOpen }, descriptionLinkText)),
        segment: segment.toLowerCase(),
    });
    const modalTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SILHOUETTE_GUIDE_MODAL_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const silhouetteGuide = useMemo(() => getSilhouetteGuide({ segment, tradename }), [segment, tradename]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { level: 3, style: style.description }, description),
        React.createElement(Text, { level: 3, style: style.description }, descriptionLink),
        React.createElement(Modal, { portalHostName: portalHostName, testID: "silhouette-guide-modal", visible: visible, scroll: true, showCloseButton: true, onClose: handleOnClose },
            React.createElement(View, { style: style.modal },
                React.createElement(Text, { level: 1, variant: "action" }, modalTitle),
                React.createElement(View, { style: style.modalGap }, silhouetteGuide.map(([key, { icon, title, description }], index) => (React.createElement(View, { key: key, style: [style.contentView, index !== 0 && style.contentGap] },
                    React.createElement(Icon, { name: icon }),
                    React.createElement(View, { style: [style.contentViewColumn, style.contentViewGap] },
                        React.createElement(Text, { level: 3, variant: "action" }, formatMessage({ id: `${i18nPrefix}${title}` }, { segment: segment.toLowerCase() })),
                        React.createElement(Text, { level: 3, style: style.description }, formatMessage({ id: `${i18nPrefix}${description}` }, { segment: segment.toLowerCase() })))))))))));
};
export { SilhouetteGuide };
